import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Col, Modal, Row } from "antd";
import CustomerDefinitionList from "./CustomerDefinitionList";
import CustomerSelect from "./CustomerSelect";
const CustomerSelectModal = ({ open, tenantId, customer, disabled = false, allowClear = true, placeholder = "Select Customer", onCancel, onCustomerSelected }) => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    useEffect(() => {
        if (open) {
            setSelectedCustomer(customer ?? null);
        }
    }, [customer, open]);
    const onSelected = (customer) => {
        setSelectedCustomer(customer);
    };
    const onOk = () => {
        onCustomerSelected(selectedCustomer);
    };
    return (_jsxs(Modal, { title: "Select Customer", open: open, onOk: onOk, onCancel: onCancel, destroyOnHidden: true, children: [_jsx(Row, { children: _jsx(Col, { xs: 24, children: _jsx(CustomerSelect, { tenantId: tenantId, disabled: disabled, allowClear: allowClear, value: selectedCustomer?.id ?? null, placeholder: placeholder, onCustomerSelected: onSelected }) }) }), _jsx(Row, { children: _jsx(Col, { xs: 24, style: { paddingTop: '20px' }, children: _jsx(CustomerDefinitionList, { customer: selectedCustomer }) }) })] }));
};
export default CustomerSelectModal;
